import React, { Component } from 'react';
import './MyClients.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import CreateClients from '../Components/CreateClients/CreateClients';
import ClientEdit from '../Components/ClientEdit/ClientEdit';
import personsm from '../../image/personsm.svg'
import plusicon from '../../image/plusicon.svg'
import axios from 'axios'
import { LinkAPI } from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import Loading from '../Components/Loading/Loading';

class MyClients extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading:true,
            inRequest:false,

            client_id: "",
            name: "",
            phone: "",
            address_name: "",
            address_alias: "",
            coordinates: [],
            nameError: "",
            phoneError: "",
            address_nameError: "",
            address_aliasError: "",
            res_done: false,
            res_donedelete: false,
            res_doneEdit: false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
        this.setStateField = this.setStateField.bind(this)
        this.getclients()
    }

    getclients = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/getclients`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                data: res.data.businessOwner.clients.reverse(),
                isLoading:false,

                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    setStateField = (object) => e => {
        this.setState({
            objectClient: object,
            client_id: object._id,
            name: object.name,
            phone: object.phone.replace(/^20+/, ''),
            address_name: object.location.address_name,
            address_alias: object.location.address_alias,
            coordinates: object.location.location.coordinates,
            nameError: "",
            phoneError: "",
            address_nameError: "",
            address_aliasError: "",
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError:false,
        })
    }
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name
        })
    }
    handelpageCreateCilent = () => {
        this.setState({
            objectClient: null,
            client_id: "",
            name: "",
            phone: "",
            address_name: "",
            address_alias: "",
            coordinates: null,
            nameError: "",
            phoneError: "",
            address_nameError: "",
            address_aliasError: "",

        })
    }
    validate = () => {
        let nameError = "";
        let phoneError = "";
        let address_nameError = "";
        let address_aliasError = "";
        if (this.state.name.length < 2 || !isNaN(this.state.name)) {
            nameError = "write your name correct";
        }
        
        if ( isNaN(this.state.phone)|| this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
            phoneError = "invalid phone Numper";
        }
        if (this.state.address_name.length < 2 || !isNaN(this.state.address_name)) {
            address_nameError = "select your location correct";
        }
        if (this.state.address_alias.length < 2 || !isNaN(this.state.address_alias)) {
            address_aliasError = "write your Address correct";
        }

        if (this.state.coordinates.length < 2) {
            address_nameError = "select your location correct";
        }
        if (nameError || phoneError || address_nameError || address_aliasError) {
            this.setState({ nameError, phoneError, address_nameError, address_aliasError });
            return false;
        }

        return true;
    };
    handleSubmitCreateClient = event => {
        event.preventDefault();
        const { name, phone, address_name, address_alias, coordinates } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validate();
        if (isValid) {
            this.setState({ inRequest:true})
            // clear form
            axios.post(`${LinkAPI}/api/businessowner/addnewclient`, {
                new_client: {
                    name: name,
                    phone: 20+phone.replace(/^0+/, ''),
                    location: {
                        address_name: address_name,
                        address_alias: address_alias,
                        location: {
                            type: "point",
                            coordinates: coordinates
                        }
                    }
                }
            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                this.getclients()
                this.setState({
                    client_id: "",
                    name: "",
                    phone: "",
                    address_name: "",
                    address_alias: "",
                    coordinates: null,
                    nameError: "",
                    phoneError: "",
                    address_nameError: "",
                    address_aliasError: "",
                    res_doneEdit: false,
                    res_done: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                })
                setTimeout(() => {
                    this.setState({
                        res_done: false,
                        inRequest:false
                    })
                }, 2000);
            }).catch(error => {
                this.HandleError(error)
            })
        }
    };
    handleSubmitEditClient = event => {
        event.preventDefault();
        const { name, phone, address_name, address_alias, coordinates, client_id } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validate();
        if (isValid) {
            this.setState({ inRequest:true})
            // clear form
            axios.put(`${LinkAPI}/api/businessowner/editclient`, {
                client: {
                    name: name,
                    phone: 20+phone.replace(/^0+/, ''),
                    location: {
                        address_name: address_name,
                        address_alias: address_alias,
                        location: {
                            type: "point",
                            coordinates: coordinates
                        }
                    }
                },
                client_id: client_id,

            }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                this.getclients()
                this.setState({
                    client_id: "",
                    name: "",
                    phone: "",
                    address_name: "",
                    address_alias: "",
                    coordinates: null,
                    nameError: "",
                    phoneError: "",
                    address_nameError: "",
                    address_aliasError: "",
                    res_done: false,
                    res_doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError: false,
                     objectClient: null
                })
                setTimeout(() => {
                    this.setState({
                        res_doneEdit: false,
                        
                        inRequest:false
                    })
                }, 2000);
            }).catch(error => {
                this.HandleError(error)
            })
        }

    };
    handleSubmitDeleteClient = event => {
        event.preventDefault();
        const { client_id } = this.state
        const Token = localStorage.getItem("userToken")
        this.setState({ inRequest:true})
        axios.delete(`${LinkAPI}/api/businessowner/deleteclient`, {
            data: { client_id: client_id },
            headers: {
                Authorization: `${Token}`
            }
        }
        ).then(res => {
            this.getclients()
            this.setState({
                client_id: "",
                name: "",
                phone: "",
                address_name: "",
                address_alias: "",
                coordinates: null,
                nameError: "",
                phoneError: "",
                address_nameError: "",
                address_aliasError: "",
                res_donedelete: true,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError: false,
                objectClient: null
            })
            setTimeout(() => {
                this.setState({
                    res_donedelete: false,
                    
                        inRequest:false
                })
            }, 2000);
        }).catch(error => {
            this.HandleError(error)
        })

    }

    render() {
        document.title ="Kayn | My Client"; 
        document.getElementsByTagName("META")[1].content="Kayn My Client";
            document.documentElement.lang = 'en';
        return (
            <div>
                <div className="AppEN row   mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className=" MyClients client col-md-11 px-lg-5">
                        <HeaderTool />
                        <div className="row " >
                        <h3 className=" col-12 fontsize9 my-0 order-8 order-8 order-md-2">My Clients</h3>

                            <div className="col-md-4 px-2 py-3 order-8 order-md-2">
                                <div className="tableDetails border shadow mx-auto">
                                    <div className="thead-light fontsize12 text-muted">
                                        <div className="headertable p-3 border">
                                            <p className="m-0">CLients BY DATE</p>
                                        </div>
                                    </div>
                                    {(this.state.isLoading?<Loading/>:
                                    <div className="fontsize12 ">
                                    {
                                       (this.state.data.length===0?<p className="  fontsize5 my-2 mx-auto text-center">No CLient Saved</p>:
                                        this.state.data.map((x, i) => (
                                            <div className={"p-3 border-bottom item-table pointer " + (this.state.client_id === x._id ? 'active' : '')} key={i} onClick={this.setStateField(x)}>
                                                <a  ><img className="mr-3" src={personsm} alt="user kayn" /><span>{x.name}</span></a>
                                            </div>)))
                                    }
                                </div>)}
                                </div>

                                {(this.state.objectClient ?
                                    <div className="createDiv p-2 text-center"><a onClick={this.handelpageCreateCilent}><button className="text-white badge-pill p-2 pl-1 px-4 border shadow bluebg text-center ">
                                        <img className="mr-2 " src={plusicon} alt="CREATE" />CREATE</button>
                                    </a>
                                    </div>
                                    : ''
                                )}
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5">
                                <div className="picbg">
                                    {(this.state.objectClient ?
                                        <ClientEdit state={this.state} handleSubmitDeleteClient={this.handleSubmitDeleteClient} handleSubmitEditClient={this.handleSubmitEditClient} handleChange={this.handleChange} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                        :
                                        <CreateClients  handleSubmitCreateClient={this.handleSubmitCreateClient} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} state={this.state} handleChange={this.handleChange} />
                                    )}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.res_done ? <HandleRes title="Client saved successfully" stylecss="alert-success" /> : '')}
                {(this.state.res_donedelete ? <HandleRes title="Client Deleted successfully" stylecss="alert-success" /> : '')}
                {(this.state.res_doneEdit ? <HandleRes title="Client edited successfully" stylecss="alert-success" /> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default MyClients;